export const environment = {
  production: true,
  version: '11.0.84',
  services: 'https://53rv.lp45a97.online:8002',
  //services: 'http://localhost:5001',
  servicesSocket : 'https://ms.lp45a97.online:8053',
  services_ast: 'https://z79ap51.online:8005',
  /** Deve coincidir com JWT_PAYLOAD_KEY no servidor ws (AES para `enc` no JWT e corpos `pld`). */
  jwtPayloadKey: '123456$#@$^@1ERF',
};
